<div class="at-container">
  <app-title-container>
    <h1>Bordereau Assessment History</h1>
    <div right>
      <button mat-flat-button (click)="newTreaty()"><mat-icon>add</mat-icon> New Bordereau Assessment</button>
    </div>
  </app-title-container>

  <div class="actions-container">
    <div>
      <mat-button-toggle-group [formControl]="myScopeControl" aria-label="Font Style" *appIsRiskManager>
        <mat-button-toggle [value]="true">My</mat-button-toggle>
        <mat-button-toggle [value]="false">All</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <mat-form-field class="keyword-search search-filter-form-field">
      <input matInput type="text" [formControl]="keywordControl" placeholder="Keyword search" />
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>
  </div>

  <app-divider height="2px"></app-divider>
  @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <div class="table-container">
    <ag-grid-angular
      style="width: 100%; height: 100%"
      [columnDefs]="colDef"
      [pagination]="true"
      [paginationPageSize]="pageSize"
      [paginationPageSizeSelector]="false"
      [defaultColDef]="defaultColDef"
      [theme]="theme"
      [rowData]="treaties()"
      [quickFilterText]="textFilter()"
      [quickFilterParser]="quickFilterParser"
      (rowClicked)="onRowClicked($event)"
    />
  </div>
</div>
